import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    makeStyles
} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    titulo: {
        color: theme.palette.primary.main
    },
    subtitulo: {
        color: theme.palette.text.primary,
        marginTop: theme.spacing(2)
    },
    texto: {
        color: theme.palette.text.disabled,
        marginTop: theme.spacing(1)
    }
}));

function CardCarroConectadoIndisponivel() {
    const classes = useStyles();

    return <>
        <Card>
            <CardContent>
                <Typography variant='h2'
                    className={classes.titulo}>
                    Ops! <span aria-hidden="true" role="img">😕</span>
                </Typography>
                <Typography variant='subtitle1'
                    className={classes.subtitulo}>
                    Essa funcionalidade ainda não está disponível para este dispositivo
                </Typography>
                <Typography variant='subtitle2'
                    className={classes.texto}>
                    Para uma experiência completa, acesse pocket.localiza.com pelo seu computador,
                    utilizando o navegador Google Chrome ou Mozilla Firefox e depois clique em
                    Carro conectado
            </Typography>
            </CardContent>
        </Card>
    </>
}

export default CardCarroConectadoIndisponivel;